import { useLocation } from "react-router-dom";

export const usePageView = <L>() => {
  const location = useLocation<L>();

  return location;
};

export default usePageView;
